import React, { Component } from 'react';

class ModalConfirmarAbandonoABMModelos extends Component {

    constructor(props) {
        super(props);

        this.continuarGuardadoModelo = this.continuarGuardadoModelo.bind(this);
    }

    continuarGuardadoModelo(dummy) {
        this.props.mostrarOcultarModalConfirmarAbandonoABMModelos("modalConfirmarAbandonoABMModelos", false);
        this.props.validarGuardarModelo();
    }
    

    render() {
        const {
            opcionElegida
        } = this.props;

        
        //ACTIONS
        const {
            mostrarOcultarModalConfirmarAbandonoABMModelos,
            routeToModelosContables
        } = this.props;

        return (
            <div className='modalContainer'>
                <div className='modalDemandaOutXS'>
                    <div className='text-right'>
                        <label onClick={() => mostrarOcultarModalConfirmarAbandonoABMModelos("modalConfirmarAbandonoABMModelos", false)} className='ti-close clickable ABMModelos__modalConfirmarEliminacionRenglon__botonCerrar'></label>
                    </div>

                    <div className='modalConfirmarSalirTextoAbandono'>
                        {"El modelo actual no fue confirmado. Hasta que el mismo no sea confirmado, no será contemplado por el proceso de contabilización."}
                    </div>

                    <div className='modalProcesosFooterShort'>
                        <button onClick={() => mostrarOcultarModalConfirmarAbandonoABMModelos("modalConfirmarAbandonoABMModelos", false)} className="btn btn-secondary">Cancelar</button>
                        <button className="btn btn-cta" onClick={() => opcionElegida == "G" ? this.continuarGuardadoModelo(null) : routeToModelosContables("")}>Aceptar</button>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalConfirmarAbandonoABMModelos;
